import script from "./Info.vue?vue&type=script&setup=true&lang=js"
export * from "./Info.vue?vue&type=script&setup=true&lang=js"

import "./Info.vue?vue&type=style&index=0&id=a78ed82c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a78ed82c"]])

export default __exports__